import { jsx } from 'react/jsx-runtime';

const SvgSocialX = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#88827E", d: "M17.751 3h3.067l-6.7 7.625L22 21h-6.172l-4.833-6.293L5.464 21h-3.07l7.167-8.155L2 3h6.328l4.37 5.752L17.75 3Zm-1.076 16.172h1.7L7.404 4.732H5.58l11.094 14.44Z" }) }));

export { SvgSocialX as default };
//# sourceMappingURL=SocialX.es.js.map
